<div class="bank-account-title-area">
  <div class="title-area-row">
    <h1 class="account-name lo_sensitive">{{ account.accountNickname }}</h1>
    @if (bankAccountType === BankAccountProvider.UnitAccount) {
      <terra-chips-status [status]="status" [statusNamespace]="statusNamespace" />
    }
  </div>
  <div class="title-area-row">
    <ul class="asset-info-wrapper desktop">
      <li class="asset-info-item" *ngIf="bankAccountType === BankAccountProvider.UnitAccount">
        <div class="asset-info-item-inner">
          <span class="asset-info-item-title">Account Type:
            <span class="asset-info-item-value">
              {{account.accountType | enumString : AccountType}}
            </span>
          </span>
          <mat-icon
            class="notranslate bank-account-type-icon"
            [svgIcon]="AccountType.getIcon(account.accountType)"
          >
          </mat-icon>
        </div>
      </li>
      <li class="asset-info-item" *ngIf="bankAccountType === BankAccountProvider.ExternalAccount">
        <div class="asset-info-item-inner">
          <span class="asset-info-item-title">Bank Name:
            <span class="asset-info-item-value">
              {{account.bankName}}
            </span>
          </span>
          <mat-icon
            class="notranslate bank-account-type-icon"
            [svgIcon]="AccountType.getIcon(account.accountType)"
          >
          </mat-icon>
        </div>
      </li>
      <li class="asset-info-item">
        <div class="asset-info-item-inner">
          <span class="asset-info-item-title">
            Account:
            <span class="asset-info-item-value">
              {{ (account.mask || account.accountNumber) | accountNumberToAstrix : 4 }}
            </span>
          </span>
          <button
            mat-icon-button
            matSuffix
            (click)="showAccountNumber(account)"
            #tooltip="matTooltip"
            matTooltip="View account info"
            matTooltipPosition="above"
          >
            <mat-icon class="notranslate" [inline]="true">visibility</mat-icon>
          </button>
        </div>
      </li>
      <li
        class="asset-info-item"
        *ngIf="account.entityName"
      >
        <div class="asset-info-item-inner">
          <span class="asset-info-item-title">{{account.entityType}}:
            <span class="asset-info-item-value" [ngClass]="{'cursor-pointer': account.entityType !== 'Business'}" (click)="goToEntity(account)">
                {{account.entityName}}
              </span>
            </span>
        </div>
      </li>
      <li class="asset-info-item" *ngIf="organization$ | async">
        <div class="asset-info-item-inner">
          <span class="asset-info-item-title"
          >Organization:
            <span class="asset-info-item-value">{{
                (organization$ | async).name
              }}</span>
          </span>
        </div>
      </li>
    </ul>
    <div class="addition-information-wrapper" *ngIf="bankAccountType === BankAccountProvider.UnitAccount">
      <button
        mat-button
        class="account-info-button additional-info"
        [matMenuTriggerFor]="bankAccountInfoMenu"
        aria-label="Show bank account info"
      >
        <span class="desktop">Transfer Limits</span>
        <mat-icon class="notranslate mobile">info</mat-icon>
      </button>
      <mat-menu
        class="cre-account-info-panel"
        #bankAccountInfoMenu="matMenu"
        xPosition="before"
      >
        <div (click)="$event.stopPropagation()">
          <div class="limit-section">
            <div class="transfer-limit-header">Transfer Limits</div>
            <terra-bank-account-limits [accountLimits]="accountLimits" />
          </div>
        </div>
      </mat-menu>
    </div>
  </div>

  <!-- Bank account info -->
</div>

<div class="content-area" [class.unit]="bankAccountType === BankAccountProvider.UnitAccount">
  <div class="left-column">
    <div class="balance-overview terra-card">
      <h3 class="balance-overview-title">Available Balance</h3>
      <div class="balance-overview-inner">
        <div class="total-numbers">
          <span class="balance-item"
          >${{ arrangeBalance(account.availableBalance) | terraCurrency }}</span
          >
          <span
            *ngIf="bankAccountType === BankAccountProvider.UnitAccount && pendingBalance > 0"
            class="balance-item pending-balance"
          >${{
              arrangeBalance(pendingBalance) | terraCurrency
            }}<span class="pending-balance-title">Pending</span></span
          >
          <span
            class="cash-sweeping-description"
            *ngIf="shouldShowCashSweepingDescription"
          >
          <mat-icon>verified_user</mat-icon>FDIC insured, up to
            $3M<mat-icon class="pointer" (click)="FDICInfo()">info</mat-icon>
          </span>
        </div>
        @if (bankAccountType === BankAccountProvider.UnitAccount) {
          <terra-unit-bank-account-actions
            [bankAccount]="account"
            (plaidSuccess)="onPlaidSuccess.emit()"
            (closeAccountSuccess)="onCloseAccountSuccess.emit()"
          />
        }
        @if (bankAccountType === BankAccountProvider.ExternalAccount) {
          <terra-external-bank-account-actions [bankAccount]="account" />
        }
      </div>
    </div>

    <div class="transactions-list" *ngIf="isGreaterThenMobileOnly$ | async">
      <ng-container *ngTemplateOutlet="transactionsList" />
    </div>
  </div>
  <div class="side-tabs" *ngIf="isMobileOnly$ | async">
    <mat-tab-group
      dynamicHeight
      mat-stretch-tabs="true"
      mat-align-tabs="start"
      [@.disabled]="true"
      (selectedTabChange)="tabChanged($event)"
    >
      <mat-tab label="TRANSACTIONS">
        <div class="tab-inner transactions-tab-inner">
          <ng-container *ngTemplateOutlet="transactionsList" />
      </div>
      </mat-tab>
      <mat-tab id="card-tab-m" label="CARDS" *ngIf="bankAccountType === BankAccountProvider.UnitAccount">
        <div class="tab-inner card-tab-inner">
          <terra-unit-cards-section #unitCardsSectionComponentMobile />
        </div>
      </mat-tab>
      <mat-tab *ngIf="bankAccountType === BankAccountProvider.UnitAccount"
      label="DOCUMENTS">
        <div class="tab-inner">
          <terra-unit-bank-account-document [bankAccount]="account" />
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div *ngIf="bankAccountType === BankAccountProvider.UnitAccount" class="side-tabs desktop-only terra-card">
    <mat-tab-group
      dynamicHeight
      mat-stretch-tabs="true"
      mat-align-tabs="start"
      [@.disabled]="true"
    >
      <mat-tab id="card-tab" label="CARDS">
        <div class="tab-inner card-tab-inner">
          <terra-unit-cards-section [refreshCards$]="refreshCards$" />
        </div>
      </mat-tab>
      <mat-tab label="DOCUMENTS">
        <div class="tab-inner">
          <terra-unit-bank-account-document [bankAccount]="account" />
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #transactionsList>
  @if (bankAccountType === BankAccountProvider.UnitAccount) {
    <terra-unit-transactions-list [bankAccountId]="account.id" [parentType]="unitParentType" />
  }
  @if (bankAccountType === BankAccountProvider.ExternalAccount) {
    <terra-plaid-transactions [bankAccountId]="account.id" />
  }
</ng-template>
